"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hitTest = exports.EHitTest = void 0;
var clickEater_sidecar_1 = require("@uiParts/clickEater-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var EHitTest;
(function (EHitTest) {
    EHitTest[EHitTest["None"] = 0] = "None";
    EHitTest[EHitTest["Over"] = 1] = "Over";
    EHitTest[EHitTest["LeftFirstDown"] = 2] = "LeftFirstDown";
    EHitTest[EHitTest["RightFirstDown"] = 3] = "RightFirstDown";
    EHitTest[EHitTest["LeftHeldDown"] = 4] = "LeftHeldDown";
    EHitTest[EHitTest["LeftUp"] = 5] = "LeftUp";
})(EHitTest = exports.EHitTest || (exports.EHitTest = {}));
var hitTest = function (img, feather) {
    if (feather === void 0) { feather = 4; }
    if (!img.visible) {
        return EHitTest.None;
    }
    if (clickEater_sidecar_1.clickEater.isCursorEaten()) {
        return EHitTest.None; // Maybe more than this?
    }
    // TODO: get in game space vs ui space?
    var _a = voyageCamera_sidecar_1.voyageCamera.getUiMousePosition(), mx = _a.mx, my = _a.my;
    // Is mx inside the frame, including feathering
    var w = img.width * img.scaleX + feather * 2;
    var h = img.height * img.scaleY + feather * 2;
    if (mx >= img.x - w / 2 && mx <= img.x + w / 2) {
        if (my >= img.y - h / 2 && my <= img.y + h / 2) {
            // TODO: play clicky sounds
            clickEater_sidecar_1.clickEater.setHoverCursor();
            clickEater_sidecar_1.clickEater.tempEatCursor();
            if (clickEater_sidecar_1.clickEater.isRightFirstDownAndUneaten()) {
                return EHitTest.RightFirstDown;
            }
            if (clickEater_sidecar_1.clickEater.isLeftFirstDownAndUneaten()) {
                return EHitTest.LeftFirstDown;
            }
            if (clickEater_sidecar_1.clickEater.isLeftDownRegardless()) {
                return EHitTest.LeftHeldDown;
            }
            if (clickEater_sidecar_1.clickEater.isLeftFirstUpAndUneaten()) {
                return EHitTest.LeftUp;
            }
            return EHitTest.Over;
        }
    }
    return EHitTest.None;
};
exports.hitTest = hitTest;
